import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export function PublicLayout({ children }) {
  return (
    <div className="relative min-h-screen">
      <div className="sadd-aurora" />
      <Navbar />
      <main className="pt-16">{children}</main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
